import { createState, useState } from '@hookstate/core';
import { CommoditySqlView } from 'shared/types';

interface ProductState {
  selectedIds: string[];
  selectedProducts: CommoditySqlView[];
}

const initialState: ProductState = {
  selectedIds: [],
  selectedProducts: [],
};

const productState = createState(initialState);

export function useProductState() {
  return useState(productState);
}
